<template>
    <div id="AdminContainer">
        <div class="container-fluid">
            <div class="row">
                <side-menu />
                <div class="main-content">
                    <AdminHeader />
                    <AdminBreadcrumb />
                    <slot />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SideMenu from "../components/Admin/SideMenu.vue";
import AdminHeader from "../components/Admin/UI/AdminHeader.vue";
import AdminBreadcrumb from "../components/Admin/UI/AdminBreadcrumb.vue";

export default {
    components: {
        SideMenu,
        AdminHeader,
        AdminBreadcrumb
    },
    data() {
        return {};
    }
};
</script>

<style lang="scss" scoped>
body {
    background: #fff !important;
    height: 100%;
    font-family: "Exo";
}
#AdminContainer {
    display: flex;
}
.main-content {
    margin-left: 240px;//16.666666666666668vw;
    width: 100%;
    background: #ffffff;
    min-height: 100vh;
}
</style>
